import React from 'react';
import { IProps, TagName, headingTags } from '@/elements/Heading/Heading.interface';
import { clsx } from 'clsx';
import { cleanHTML } from '@/utils/sanitizeHTML'; // Import the utility function
import '@/elements/Heading/Heading.styles.css';

const Heading: React.FC<IProps> = (props) => {
    const { id, level, className, html, children } = props;

    const Component = headingTags[level] as TagName;

    const combinedClassName = clsx('heading', className);

    if (html) {
        return (
            <Component
                id={id || undefined}
                className={combinedClassName}
                dangerouslySetInnerHTML={{ __html: cleanHTML(html) }} // Use the sanitized HTML
            />
        );
    }

    return (
        <Component id={id || undefined} className={combinedClassName}>
            {children}
        </Component>
    );
};
export default Heading;
